module.exports = __webpack_public_path__ + "static/20-6-b3da873614fa888a78e92b870830715e.jpg";